module.exports = __webpack_public_path__ + "img/image5@3x.f7dbcc5d.png";